export const siteInfo = {
  name: '爆料前线',
  domain: 'https://97go.cn',
  tagline: '实时热点追踪 · 突发新闻速递',
  slogan: '刚发生的瓜，正在冲榜的话题，一屏看全',
  intro:
    '爆料前线把今日鲜料、突发新闻和全网热搜榜集中进同一屏，实时盯住事件冲到哪一步。不用再开多个 App 来回切，吃瓜闲逛和跟进舆情都能在一处完成。',
  email: 'news@baoliaopai.example.com',
  nav: [
    { label: '首页', path: '/' },
    { label: '热搜榜', path: '/ranking' },
    { label: '突发新闻', path: '/breaking' },
    { label: '关于我们', path: '/about' },
    { label: '联系我们', path: '/contact' },
  ],
  socials: [
    { label: '微博', icon: 'ri-weibo-line', href: '#' },
    { label: '微信', icon: 'ri-wechat-line', href: '#' },
    { label: '抖音', icon: 'ri-tiktok-line', href: '#' },
    { label: '小红书', icon: 'ri-book-2-line', href: '#' },
  ],
};

export const faqList = [
  {
    question: '爆料前线主要提供什么内容？',
    answer:
      '我们把今日鲜料、突发新闻和全网热搜榜整理到同一屏，按热度与时间双维度排序，方便你快速判断事件正在冲到哪一步。',
  },
  {
    question: '热搜榜单多久更新一次？',
    answer:
      '榜单在工作时段内持续滚动更新，热度值来自站内阅读、评论与外部讨论量的综合统计，每十五分钟刷新一次排序。',
  },
  {
    question: '我可以在平台上投稿线索吗？',
    answer:
      '可以。在联系我们页面填写线索投稿表单即可，请尽量提供时间、地点与可核实的细节，编辑团队会优先处理信息完整的线索。',
  },
  {
    question: '平台上的内容来源可靠吗？',
    answer:
      '每条话题都会标注时间节点与进展状态。我们坚持先核实再发布，对尚未确认的说法会明确标注为待核实，不做定论性表述。',
  },
  {
    question: '怎么跟进某个事件的后续进展？',
    answer:
      '进入话题详情页即可看到完整时间线，事件有新的进展时，时间线会追加最新节点，相关话题也会在页面底部同步更新。',
  },
  {
    question: '只想看某一类话题怎么办？',
    answer:
      '首页和热搜榜页面都提供分类筛选，你也可以直接进入某个分类页，只浏览该领域的全部话题。',
  },
];

export const principles = [
  {
    icon: 'ri-shield-check-line',
    title: '先核实再发布',
    desc: '未经多方交叉确认的说法不会以定论形式呈现，页面会明确标注进展状态与待核实信息。',
  },
  {
    icon: 'ri-time-line',
    title: '时间线优先',
    desc: '每个话题都以时间线组织关键节点，让你一眼看清事件从哪里开始、现在走到哪一步。',
  },
  {
    icon: 'ri-link-m',
    title: '标注来源与进展',
    desc: '重要节点注明信息出处与更新时间，后续出现反转或补充时，在原话题内直接追加说明。',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '不做情绪放大',
    desc: '标题克制、拒绝夸张渲染，把判断空间留给读者，不用刺激性表述换取点击。',
  },
];

export const testimonials = [
  {
    name: '早八地铁人',
    role: '通勤族',
    quote: '以前刷热搜要开三个 App，现在早上在地铁上翻一遍爆料前线就够了，榜单排序基本和大家的讨论节奏对得上。',
  },
  {
    name: '柠檬不加冰',
    role: '内容爱好者',
    quote: '最喜欢的是时间线设计。一个瓜从出现到反转，节点都留痕，不用再翻聊天记录找前情。',
  },
  {
    name: '小城观察员',
    role: '社区志愿者',
    quote: '本地暴雨那次，我从这里看到抢险进度比群里转发的消息还快，后来就一直拿它当入口。',
  },
  {
    name: '夜班编辑老周',
    role: '媒体从业者',
    quote: '分类筛选做得很实用，只盯财经和职场两个频道，信息噪声少了很多，选题也顺手。',
  },
];

export const milestones = [
  { year: '2023', title: '从一张表格开始', desc: '最初只是编辑团队内部用来记录热点推进情况的一张在线表格。' },
  { year: '2024', title: '时间线上线', desc: '把零散的更新整理成可回溯的时间线，读者第一次能完整看到事件脉络。' },
  { year: '2025', title: '分类频道拆分', desc: '按领域拆出八个内容频道，让关注面更窄的用户也能快速找到想看的话题。' },
  { year: '2026', title: '一屏聚合', desc: '热搜榜、突发速递与鲜料流整合进首页，形成现在的信息结构。' },
];

export const stats = [
  { value: '8', label: '内容频道', suffix: '个' },
  { value: '15', label: '榜单刷新', suffix: '分钟' },
  { value: '2.6', label: '日均话题', suffix: '万条' },
  { value: '120', label: '覆盖城市', suffix: '座' },
];